import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionRemoveItem } from '../../../utils/sessionHelpers'
import AssetRequestManagementWidgets from '../../../widgets/assetRequestManagementWidgets/AssetRequestManagementWidgets'
import AssetRequestManagementDetailWidgets from '../../../widgets/assetRequestManagementDetailWidgets/AssetRequestManagementDetailWidgets'
import AssetRequestManagementApproveWidgets from '../../../widgets/assetRequestManagementApproveWidgets/AssetRequestManagementApproveWidgets'
import { getAssetRequestManagementApprove } from '../../../redux/actions/assetRequestManagementApprove'

export default function AssetRequestManagementApprove() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetRequestManagementApprove(1, 5)
      console.log('schema ----> ', _schema)

      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader
          header={schema.header}
          subHeader={schema?.subHeader || ''}
          isNotCallApi
          isShowGoButton
        />

        <AssetRequestManagementApproveWidgets schema={schema.form} />

        {/* <AssetRequestManagementWidgets schema={schema.form} isApprover/> */}

        {/* <AssetRequestManagementDetailWidgets schema={schema.form} isApprover/> */}

        <br />
      </SidebarProposal>
    </div>
  )
}
